export const signMessage = async (signer, message: string): Promise<string> => {
  if (!signer || !message) return
  return signer.signMessage(message)
}
